import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import OrderInfo from './OrderInfo';
import PaymentMethod from './PaymentMethod';
import DeliveryInfoForm from './DeliveryInfoForm';
import _cartUtils from '../../../utils/cart.utils';
import { GLOBAL } from '../../../constants/global.const';
import { Form } from 'react-final-form';
import validate from './validate';
import orderApis from '../../../apis/order.api';
import alertUtils, { SWAL } from '../../../utils/alert.util';
import cartUtils from '../../../utils/cart.utils';

const PaymentInfo = () => {
    const [isShow, setIsShow] = useState(true);
    const locationInfo = useRef({});
    const initialValues = useRef({
        cityId: '',
        districtId: '',
        wardId: '',
        address: '',
        addressName: '',
        customerName: '',
        email: '',
        phoneNumber: '',
        isAutoRegister: false,
    });

    const checkShowInfo = () => {
        const cartStorage = _cartUtils.get();
        if (!cartStorage) {
            setIsShow(false);
            return;
        }
        const listStorage = JSON.parse(cartStorage);
        if (listStorage.length === 0) {
            setIsShow(false);
            return;
        }
        setIsShow(true);
    };

    const onSubmitForm = async (s) => {
        alertUtils.showLoading('Đang tiến hành đặt hàng...');
        const dataPost = {
            ...initialValues.current,
            ...locationInfo.current,
            ...s,
        };
        const { status, data } = await orderApis.create(dataPost);
        if (status !== 200) {
            alertUtils.show(SWAL.TYPE.ERR, data.msg);
            return;
        }
        cartUtils.setNoDispatch([]);

        window.location.href = `/dat-hang-thanh-cong?orderid=${data.data}`;
    };

    const onOrderChange = (s) => {
        initialValues.current = {
            ...initialValues.current,
            listCartItem: s,
        };
    };

    const onPaymentMethodChange = (s) => {
        initialValues.current = {
            ...initialValues.current,
            paymentMethod: s,
        };
    };

    const onLocationChange = (s) => {
        locationInfo.current = s;
    };

    const showHtml = () => {
        try {
            if (!isShow) {
                return (
                    <div className="cart-box-container check-out">
                        <div className="container container-ver2">
                            <p>Không có thông tin sản phẩm</p>
                        </div>
                    </div>
                );
            }
            return (
                <div className="cart-box-container check-out">
                    <Form
                        onSubmit={onSubmitForm}
                        validate={validate}
                        initialValues={initialValues.current}
                        render={({
                            handleSubmit,
                            values,
                            invalid,
                            submitting,
                        }) => (
                            <div className="container container-ver2">
                                <div className="row">
                                    <div className="col-md-6">
                                        <DeliveryInfoForm
                                            values={values}
                                            onChange={onLocationChange}
                                        />
                                    </div>

                                    <div className="col-md-6 space-30">
                                        <div className="box">
                                            <OrderInfo
                                                onChange={onOrderChange}
                                            />
                                            <PaymentMethod
                                                onChange={onPaymentMethodChange}
                                            />

                                            <button
                                                className="link-v1 box lh-50 rt full"
                                                title="ĐẶT HÀNG"
                                                onClick={handleSubmit}
                                                disabled={invalid || submitting}
                                            >
                                                ĐẶT HÀNG
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    ></Form>
                </div>
            );
        } catch (err) {
            console.log(err);
            return (
                <div className="cart-box-container check-out">
                    <div className="container container-ver2">
                        <p>Không có thông tin sản phẩm</p>
                    </div>
                </div>
            );
        }
    };

    useEffect(() => {
        checkShowInfo();
    }, []);

    window.addEventListener('storage', ({ key }) => {
        console.log(key);
        if (key === GLOBAL.CART_STORAGE) {
            checkShowInfo();
        }
    });

    return <>{showHtml()}</>;
};

PaymentInfo.propTypes = {};

export default PaymentInfo;

document.querySelectorAll('react-payment-info').forEach((domContainer) => {
    const root = createRoot(domContainer);

    root.render(<PaymentInfo />);
});
